export default __webpack_public_path__ + "static/media/mastering_content_vector.661a182b.svg";